<template lang="html">
  <div class="tab">
    <main class="page_container">
      <el-table v-loading="loading" class="list" :row-class-name="tableRowClassName" :data="cameras">
        <el-table-column prop="short_name" label="Камера">
          <template slot-scope="scope">
            <router-link class="link" :to="{ name: 'cameras:edit', params: { id: scope.row.id_camera } }">
              {{ scope.row.short_name }}
            </router-link>
          </template>
        </el-table-column>
        <el-table-column prop="server_name" label="Сервер" />
        <el-table-column prop="address" label="Адрес" />
        <el-table-column prop="ip" label="ip" />
        <el-table-column prop="enabled" label="Все уведомления">
          <template slot-scope="scope">
            <el-checkbox :value="Boolean(scope.row.enabled)" />
          </template>
        </el-table-column>
        <el-table-column prop="notify_about_detection" label="Детекция">
          <template slot-scope="scope">
            <el-checkbox :value="Boolean(scope.row.notify_about_detection)" />
          </template>
        </el-table-column>
        <el-table-column prop="notify_about_intercom_calls" label="Домофон">
          <template slot-scope="scope">
            <el-checkbox :value="Boolean(scope.row.notify_about_intercom_calls)" />
          </template>
        </el-table-column>
        <el-table-column prop="notify_about_monitoring" label="Мониторинг">
          <template slot-scope="scope">
            <el-checkbox :value="Boolean(scope.row.notify_about_monitoring)" />
          </template>
        </el-table-column>
        <el-table-column prop="notify_by_push" label="Пуш">
          <template slot-scope="scope">
            <el-checkbox :value="Boolean(scope.row.notify_by_push)" />
          </template>
        </el-table-column>
        <el-table-column prop="notify_by_telegram" label="Телеграм">
          <template slot-scope="scope">
            <el-checkbox :value="Boolean(scope.row.notify_by_telegram)" />
          </template>
        </el-table-column>
      </el-table>
    </main>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "ClientCamerasList",
  props: {
    clientId: {
      type: Number,
      required: true,
    },
    showDeletedCameras: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState("client", ["cameras"]),
  },
  watch: {
    clientId: {
      immediate: true,
      handler() {
        this.loadCamerasList()
      },
    },
    showDeletedCameras() {
      this.loadCamerasList()
    }
  },
  methods: {
    ...mapActions("client", {
      getCameras: "GET_CLIENT_CAMERAS",
    }),
    loadCamerasList() {
      this.loading = true;
      this.getCameras({
        clientId: this.clientId,
        showDeleted: this.showDeletedCameras
      })
        .finally(() => {
          this.loading = false;
        });
    },
    tableRowClassName({row}) {
      return row.is_deleted === 1 ? 'deleted-row' : null;
    },
  },
};
</script>

<style lang="scss">
.deleted-row td {
  opacity: 0.3;
}
</style>
